export default __webpack_public_path__ + "static/media/ELEMENTOS_11.894b5a48.png";